import { convertDate } from '@/common/util';

class StackingResult {
    constructor(result) {
        this.id = result.id;
        this.season = result.season;
        this.name = result.name;
        if (result.sanctioned === false)
            this.name += "*";

        this.wssaLink = result.wssaLink;
        this.date = convertDate(result.date);
        this.length = result.length;
        this.location = result.location;
        this.coords = result.coords;
        this.finals333 = result.finals333;
        this.finals363 = result.finals363;
        this.finalsCycle = result.finalsCycle;
        this.finalsDoubles = result.finalsDoubles;
        this.finalsRelay = result.finalsRelay;
        this.tags = result.tags;
        if (!this.tags)
            this.tags = [];

        const hasCombinedTime = typeof (result.finals333) === "number"
            && typeof (result.finals363) === "number"
            && typeof (result.finalsCycle) === "number";
        
        if (hasCombinedTime)
            this.finalsCombined = result.finals333 + result.finals363
                + result.finalsCycle;

        const qualifiedForCombinedTime = result.finals333 !== "DNQ"
            && result.finals363 !== "DNQ"
            && result.finalsCycle !== "DNQ"
        
        if (!qualifiedForCombinedTime)
            this.finalsCombined = "DNQ";
    }
}

function fetchMappedResults() {
    return fetch("https://jonscannell-com.firebaseio.com/tournaments.json")
        .then(response => response.json())
        .then(data => data.map(result => new StackingResult(result)));
}

export { fetchMappedResults };